document.addEventListener("DOMContentLoaded", function() {
	var $form = $('.contact-form');
	var $submit = $('#contact-submit');
	var $alert = $('.alert');
	var $alertMessage = $('.alert-message');
	var processing = 0;
	var spinner = null;

	function showAlert(message) {
		$alert.show().find('.alert-message').text(message);
	}

	function startProcessing() {
		processing = 1;
		$submit.html('&nbsp;&nbsp;&nbsp;Processing');
		spinner = new Spinner($.extend(true, {}, DEFAULT_SPIN_OPTS, { color : '#333', scale : 0.20, left : 25, top : 17 })).spin($submit[0]);
	}

	function stopProcessing() {
		spinner.stop();
		$submit.text("Submit");
		processing = 0;
	}

	// send another message
	$('.btn-send-message').on('click', function() {
		window.location = window.location.pathname.replace(/[-_]thankyou/, '');
	});

	// submit contact
	$form.on('submit', function(e) {
		e.preventDefault();
		if (processing) {
			return;
		}

		startProcessing();
		
		var values = $(this).serializeArray();
		var data = {};
		values.forEach(function(o) {
			data[o.name] = String(o.value||"").trim()
		});

		// reset validation
		$alert.hide();
		$('.is-invalid').removeClass('is-invalid');

		var validate = [ "name", "email", "phone", "orgname", "group_size", "preferred_date", "preferred_times" ];
		var errors = 0;

		validate.forEach(function(name) {
			if (data[name] !== undefined && data[name].length === 0) {
				$('input[name="' + name + '"],textarea[name="' + name + '"],select[name="' + name + '"]').addClass('is-invalid');
				errors += 1;
			}
		});

		// form should be filled
		if (errors > 0) {
			if (ENABLE_ANALYTICS) {
				gtag('event', 'failed validation', { send_to : 'G-9BF9PSVTG2', event_category : 'groups', event_label : 'missing fields' });
			}
			if (typeof hj === 'function') {
				hj('formSubmitFailed');
			}
			showAlert('Please fill out the entire form before sending.');
			stopProcessing();
			return;
		}

		// email valid
		if (!EMAIL_REGEX.test(data['email'])) {
			if (ENABLE_ANALYTICS) {
				gtag('event', 'failed validation', { send_to : 'G-9BF9PSVTG2', event_category : 'groups', event_label : 'invalid email' });
			}
			if (typeof hj === 'function') {
				hj('formSubmitFailed');
			}
			showAlert('Your email doesn\'t appear to be valid.');
			stopProcessing();
			return;
		}

		// test phone
		if ($('input[name="phone"]').length === 1 && /[A-Za-z]/.test(data['phone'])) {
			if (ENABLE_ANALYTICS) {
				gtag('event', 'failed validation', { send_to : 'G-9BF9PSVTG2', event_category : 'groups', event_label : 'invalid phone' });
			}
			if (typeof hj === 'function') {
				hj('formSubmitFailed');
			}
			showAlert('Your phone number doesn\'t appear to be valid.');
			stopProcessing();
			return;
		}

		var category = window.location.pathname.indexOf('social') > -1 ? 'social' : 'groups';
		executeRecaptcha("groups").then(function(token) {
			data["g-recaptcha-token"] = token;
			$.ajax({
				type     : "post",
				url      : "/api/contact/groups",
				data     : data,
				cache    : false,
				dataType : 'json',
				success : function(response) {
					if (response.success === 0) {
						if (ENABLE_ANALYTICS) {
							gtag('event', 'error', { send_to : 'G-9BF9PSVTG2', event_category : 'groups', event_label : 'failed' });
						}
						if (typeof hj === 'function') {
							hj('formSubmitFailed');
						}
						showAlert(response.message);
						stopProcessing();
						return;
					}
					if (ENABLE_ANALYTICS) {
						gtag('event', 'sent', { send_to : 'G-9BF9PSVTG2', event_category : 'groups' });
					}
					if (typeof hj === 'function') {
						hj('formSubmitSuccessful');
					}
					if (typeof fbq !== 'undefined') {
						fbq('track', 'ContactForm', { content_name : category });
					}

					setTimeout(function() {
						window.location = window.location.pathname + (window.location.pathname.indexOf('_') > -1 ? '_' : '-') + 'thankyou';
					}, 500);
					stopProcessing();
				},
				error : function(xhr, status) {
					if (ENABLE_ANALYTICS) {
						gtag('event', 'error', { send_to : 'G-9BF9PSVTG2', event_category : 'groups', event_label : 'failed' });
					}
					if (typeof hj === 'function') {
						hj('formSubmitFailed');
					}
					showAlert("There was a connection error. Please try again.");
					stopProcessing();
				}
			});
		}).catch(function() {
			showAlert("There was a connection error. Please try again.");
			stopProcessing();
		});

		return false;
	});
});
